import axios from "axios";
import { API } from "@/lib/api";

// Os valores cobrados de verdade ficam no Stripe; estes sao so para mostrar na tela.
export const PLANOS = [
  {
    id: "mensal",
    nome: "Mensal",
    preco: 25,
    precoTexto: "R$ 25",
    periodo: "/mês",
    porMes: null,
    economia: null,
    descricao: "Cobrança todo mês no cartão",
  },
  {
    id: "trimestral",
    nome: "Trimestral",
    preco: 50,
    precoTexto: "R$ 50",
    periodo: "/trimestre",
    porMes: "R$ 16,67 por mês",
    economia: "33% de economia",
    descricao: "Cobrança a cada 3 meses no cartão",
  },
  {
    id: "anual",
    nome: "Anual",
    preco: 180,
    precoTexto: "R$ 180",
    periodo: "/ano",
    porMes: "R$ 15 por mês",
    economia: "40% de economia",
    descricao: "Cobrança uma vez por ano no cartão",
    destaque: true,
  },
];

export const nomeDoPlano = (id) => PLANOS.find((p) => p.id === id)?.nome || "";

export function rastrear(evento, dados = {}) {
  try {
    if (window.fbq) window.fbq("track", evento, dados);
  } catch (e) {}
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: evento, ...dados });
  } catch (e) {}
}

// Abre o checkout do Stripe para o plano escolhido. Serve para quem esta
// comprando pela primeira vez e para quem esta renovando (com login).
export async function irParaPagamento(planoId) {
  const plano = PLANOS.find((p) => p.id === planoId);
  rastrear("InitiateCheckout", {
    value: plano?.preco,
    currency: "BRL",
    content_name: `Aesthetica Pricing Pro - ${plano?.nome || planoId}`,
  });
  const res = await axios.post(`${API}/stripe/create-checkout-session`, {
    origin_url: window.location.origin,
    plano: planoId,
  });
  window.location.href = res.data.url;
}

export function formatarData(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
  } catch (e) {
    return "";
  }
}

export const STATUS_ASSINATURA = {
  active: "Ativa",
  trialing: "Em teste",
  past_due: "Pagamento pendente",
  canceled: "Cancelada",
  unpaid: "Não paga",
  incomplete: "Pagamento incompleto",
  incomplete_expired: "Pagamento expirado",
  paused: "Pausada",
};
